import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import HeroGameOne from "../assets/images/game/image-02.png";
import HeroGameTwo from "../assets/images/game/image-14.png";
import HeroGameThree from "../assets/images/game/image-39.png";
import HeroGameFour from "../assets/images/game/image-58.png";
import HeroGameFive from "../assets/images/game/image-71.png";
import HeroGameSix from "../assets/images/game/image-24.png";

import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class Index extends Component {
  componentDidMount() {
    loading(false);
  }

  getGameAvailability = (item) => {
    if (
      item.available === false ||
      item.active === false ||
      item.enabled === false ||
      item.disabled === true ||
      item.maintenance === true ||
      item.status === false
    ) {
      return false;
    }
    if (typeof item.status === "string") {
      const normalizedStatus = item.status.toLowerCase();
      if (
        normalizedStatus.includes("close") ||
        normalizedStatus.includes("offline") ||
        normalizedStatus.includes("disable") ||
        normalizedStatus.includes("maintenance") ||
        normalizedStatus.includes("ไม่พร้อม")
      ) {
        return false;
      }
    }
    return true;
  };

  // การ์ดเกมที่นำกลับมาใช้ซ้ำในทุก section
  renderGameCard = (item, source) => {
    const isAvailable = this.getGameAvailability(item);
    const linkIndex = item.sectionIndex;
    const imageIndex = String((item.masterIndex || 0) + 2).padStart(2, "0");
    return (
      <div
        className={`col-6 col-sm-4 col-md-4 col-xl-3 mb-4 product ${isAvailable ? "pointer" : ""}`}
        key={`${source}-${item.name}-${linkIndex}`}
        title={item.name}
        onClick={() => {
          if (!isAvailable) return;
          window.location.href = `/payment-game?source=${source}&id=${linkIndex}`;
        }}
      >
        <div className={`game-card h-100 ${!isAvailable ? "game-card--disabled" : ""}`}>
          <div className="game-card__image-wrap">
            <img
              src={require(`../assets/images/game/image-${imageIndex}.png`)}
              alt={item.name}
              className="w-100 hpx-120 mx-auto rounded-4 game-card__image"
              style={{ objectFit: "cover" }}
            />
            <div className="game-card__shine"></div>
          </div>
          <div className="game-card__body">
            <span className={`game-card__chip game-card__chip--${isAvailable ? "ready" : "offline"}`}>
              {isAvailable ? "พร้อมใช้งาน" : "ไม่พร้อมใช้งาน"}
            </span>
            <b className="game-card__title text-center">{item.name}</b>
          </div>
        </div>
      </div>
    );
  };

  // section รายการเกม + ปุ่มดูทั้งหมด (โครงเดียวกับ overtopup)
  renderSection = ({ label, title, subtitle, items, href, source }) => {
    const list = (items || []).slice(0, 8);
    if (!list.length) return null;
    return (
      <section className="home-section" key={source}>
        <div className="home-section__head">
          <div>
            <span className="game-panel__label">{label}</span>
            <h3 className="home-section__title text-white">{title}</h3>
            <small className="text-white-50">{subtitle}</small>
          </div>
          <a className="home-section__view" href={href}>
            ดูทั้งหมด <span aria-hidden="true">→</span>
          </a>
        </div>
        <div className="game-panel">
          <div className="row">{list.map((item) => this.renderGameCard(item, source))}</div>
        </div>
      </section>
    );
  };

  render() {
    const services = [
      { title: "เติมเกม UID", desc: "เติมตรงเข้าเกมด้วย UID", href: "/game-uid", icon: "🎮", tag: "ยอดนิยม" },
      { title: "เติมเกม ID-PASS", desc: "ล็อกอินบัญชีเพื่อเติม", href: "/topup-id-pass", icon: "🔐", tag: "ปลอดภัย" },
      { title: "บัตรเติมเกม", desc: "ซื้อโค้ด / บัตรเติมเงิน", href: "/card-topup", icon: "🎟️", tag: "หลากหลาย" },
      { title: "เติมเงินมือถือ", desc: "เติมเบอร์ทุกเครือข่าย", href: "/payment-mobile", icon: "📱", tag: "24 ชม." },
    ];

    const sections = [
      {
        label: "Game Collection",
        title: "เติมเกม UID",
        subtitle: "เติมตรงเข้าเกมยอดนิยมด้วย UID พร้อมเติมทันที",
        items: global.game_uid,
        href: "/game-uid",
        source: "game-uid",
      },
      {
        label: "Account Topup",
        title: "เติมเกม ID-PASS",
        subtitle: "เติมผ่านการล็อกอินบัญชีเกม ปลอดภัย มั่นใจ",
        items: global.topup_id_pass,
        href: "/topup-id-pass",
        source: "topup-id-pass",
      },
      {
        label: "Game Cards",
        title: "บัตรเติมเกม",
        subtitle: "บัตรเติมเกมและบัตรเติมเงินออนไลน์หลากหลายแบรนด์",
        items: global.card_topup,
        href: "/card-topup",
        source: "card-topup",
      },
    ];

    const heroBenefits = [
      "รองรับทั้งเกมมือถือและเกมออนไลน์หลายหมวด",
      "มีโบนัส และโปรโมชันสำหรับบางแพ็กเติม",
    ];
    const leftHeroSteps = ["เลือกเกม", "เลือกแพ็ก", "เติมเงิน"];

    const news = [
      {
        tag: "โปรโมชัน",
        title: "รวมดีลเติมเกมสุดคุ้มประจำเดือน รับโบนัสเพิ่มหลายแพ็ก",
        excerpt: "อัปเดตโปรโมชันและแพ็กเติมที่คุ้มที่สุด พร้อมโบนัสพิเศษสำหรับเกมยอดนิยม",
        date: "10 มิ.ย. 2026",
        views: "1.2k",
      },
      {
        tag: "อัปเดต",
        title: "เพิ่มเกมใหม่และช่องทางชำระเงินที่หลากหลายยิ่งขึ้น",
        excerpt: "ตอนนี้รองรับเกมเพิ่มเติมและช่องทางชำระเงินใหม่ เติมได้สะดวกและรวดเร็วกว่าเดิม",
        date: "5 มิ.ย. 2026",
        views: "860",
      },
      {
        tag: "แนะนำ",
        title: "วิธีเติมเกมให้ปลอดภัย และข้อควรรู้ก่อนทำรายการ",
        excerpt: "เคล็ดลับการตรวจสอบข้อมูลก่อนเติม เพื่อให้ทุกการทำรายการราบรื่นและปลอดภัย",
        date: "1 มิ.ย. 2026",
        views: "2.4k",
      },
    ];

    const features = [
      { icon: "⚡", title: "เติมไว ทันใจ", desc: "ระบบอัตโนมัติ รับของทันทีหลังชำระเงินสำเร็จ" },
      { icon: "🛡️", title: "ปลอดภัยมั่นใจ", desc: "ช่องทางชำระเงินที่เชื่อถือได้ พร้อมยืนยันตัวตน" },
      { icon: "🕐", title: "บริการ 24 ชม.", desc: "เติมได้ทุกที่ทุกเวลา ตลอด 24 ชั่วโมง" },
      { icon: "💎", title: "ดีลคุ้มค่า", desc: "ราคาดี มีโบนัสและโปรโมชันในหลายแพ็กเกจ" },
    ];

    return (
      <div className="game-page w-100 min-vh-100 position-relative overflow-hidden">
        <div className="game-page__ambient game-page__ambient--one"></div>
        <div className="game-page__ambient game-page__ambient--two"></div>
        <div className="game-page__grid"></div>

        <Navbar />

        <div className="container position-relative py-3">
          {/* ===== HERO ===== */}
          <section className="game-hero mb-4 mb-lg-5">
            <div className="game-hero__backdrop" aria-hidden="true">
              <div className="game-hero__backdrop-glow game-hero__backdrop-glow--gold"></div>
              <div className="game-hero__backdrop-glow game-hero__backdrop-glow--blue"></div>
              <div className="game-hero__backdrop-overlay"></div>
              <div className="game-hero__media game-hero__media--lg"><img src={HeroGameOne} alt="" /></div>
              <div className="game-hero__media game-hero__media--md"><img src={HeroGameTwo} alt="" /></div>
              <div className="game-hero__media game-hero__media--sm"><img src={HeroGameThree} alt="" /></div>
              <div className="game-hero__media game-hero__media--accent"><img src={HeroGameFour} alt="" /></div>
              <div className="game-hero__media game-hero__media--wide"><img src={HeroGameFive} alt="" /></div>
              <div className="game-hero__media game-hero__media--tall"><img src={HeroGameSix} alt="" /></div>
              <div className="game-hero__token game-hero__token--one">UC +325</div>
              <div className="game-hero__token game-hero__token--two">Diamonds x720</div>
              <div className="game-hero__token game-hero__token--three">Coin Cashback</div>
              <div className="game-hero__backdrop-streak"></div>
            </div>
            <div className="row align-items-center g-4">
              <div className="col-12 col-lg-7">
                <span className="game-hero__eyebrow mb-3 d-inline-flex">Top-Up Experience</span>
                <h1 className="game-hero__title text-white mb-3">
                  <span className="game-hero__brand">Lvup Topup</span>
                  <span className="game-hero__title-sub">เติมเกมและแพ็กยอดนิยม สำหรับเกมฮิต</span>
                </h1>
                <p className="game-hero__description mb-4">
                  เติมเกมออนไลน์ เติมเกมมือถือ ตลอด 24 ชม. กับ <b>Lvup Topup</b> รองรับเกมชั้นนำมากกว่า 30 เกม เลือกแพ็กและเติมเงินได้อย่าง รวดเร็ว พร้อมดีลคุ้มค่าในทุกช่วงเวลา
                </p>
                <div className="game-hero__flow-strip mb-4">
                  {leftHeroSteps.map((item) => (
                    <span key={item} className="game-hero__flow-step">{item}</span>
                  ))}
                </div>
                <div className="game-hero__actions">
                  <a href="/game-uid" className="game-hero__cta-primary">สั่งซื้อทันที</a>
                  <a href="/card-topup" className="game-hero__cta-ghost">ดูบัตรเติมเกม</a>
                </div>
              </div>

              <div className="col-12 col-lg-5">
                <div className="game-hero__spotlight">
                  <div className="game-hero__avatars" aria-hidden="true">
                    <div className="game-hero__avatar game-hero__avatar--main"><img src={HeroGameSix} alt="" /></div>
                    <div className="game-hero__avatar game-hero__avatar--sub"><img src={HeroGameOne} alt="" /></div>
                    <div className="game-hero__pack-card">
                      <span className="game-hero__pack-label">Game Pack</span>
                      <b>720 Diamonds</b>
                      <small>พร้อมเติมทันที</small>
                    </div>
                  </div>
                  <div className="game-hero__spotlight-ring"></div>
                  <div className="game-hero__spotlight-card">
                    <div className="game-hero__spotlight-badge">TOPUP SERVICE</div>
                    <h4 className="text-white fw-bold mb-3">เติมเกมที่หยิบใช้ง่ายเหมือนหน้า store</h4>
                    <p className="text-white-50 mb-4">เลือกเกม และชำระเงินได้ทันที</p>
                    <div className="game-hero__benefits mb-4">
                      {heroBenefits.map((item) => (
                        <div className="game-hero__benefit" key={item}>
                          <span className="game-hero__benefit-dot"></span>
                          <span>{item}</span>
                        </div>
                      ))}
                    </div>
                    <div className="game-hero__checkout">
                      <div className="game-hero__checkout-top">
                        <span>Featured Top-up</span>
                        <b>Best Seller</b>
                      </div>
                      <div className="game-hero__checkout-steps">
                        <span>325 UC</span>
                        <span>720 Diamonds</span>
                        <span>Battle Pass</span>
                      </div>
                    </div>
                    <div className="game-hero__tags mt-4">
                      <span>Instant Delivery</span>
                      <span>Bonus Coins</span>
                      <span>Trusted Payment</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ===== SERVICE CATEGORY CARDS ===== */}
          <section className="home-services mb-4 mb-lg-5">
            <div className="row g-3 g-lg-4">
              {services.map((s) => (
                <div className="col-6 col-lg-3" key={s.title}>
                  <a href={s.href} className="home-service-card">
                    <span className="home-service-card__icon" aria-hidden="true">{s.icon}</span>
                    <div className="home-service-card__body">
                      <b className="home-service-card__title">{s.title}</b>
                      <small className="home-service-card__desc">{s.desc}</small>
                    </div>
                    <span className="home-service-card__tag">{s.tag}</span>
                    <span className="home-service-card__arrow" aria-hidden="true">→</span>
                  </a>
                </div>
              ))}
            </div>
          </section>

          {/* ===== GAME SECTIONS (UID / ID-PASS / CARDS) ===== */}
          {sections.map((section) => this.renderSection(section))}

          {/* ===== NEWS ===== */}
          <section className="home-section">
            <div className="home-section__head">
              <div>
                <span className="game-panel__label">Latest News</span>
                <h3 className="home-section__title text-white">ข่าวสารล่าสุด</h3>
                <small className="text-white-50">อัปเดตโปรโมชัน ข่าวสาร และเคล็ดลับการเติมเกม</small>
              </div>
              <a className="home-section__view" href="/">
                ดูทั้งหมด <span aria-hidden="true">→</span>
              </a>
            </div>
            <div className="row g-3 g-lg-4">
              {news.map((n) => (
                <div className="col-12 col-md-4" key={n.title}>
                  <a href="/" className="home-news-card h-100">
                    <div className="home-news-card__thumb">
                      <span className="home-news-card__tag">{n.tag}</span>
                    </div>
                    <div className="home-news-card__body">
                      <b className="home-news-card__title">{n.title}</b>
                      <small className="home-news-card__excerpt">{n.excerpt}</small>
                      <div className="home-news-card__meta">
                        <span>🗓 {n.date}</span>
                        <span>👁 {n.views}</span>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </section>

          {/* ===== WHY CHOOSE US ===== */}
          <section className="home-why mt-2 mb-5">
            <div className="text-center mb-4">
              <span className="game-panel__label">Why Choose Us</span>
              <h3 className="home-section__title text-white mt-2">ทำไมต้องเติมกับ Lvup Topup</h3>
              <small className="text-white-50">ครบ จบ ในที่เดียว ด้วยบริการที่ออกแบบมาเพื่อเกมเมอร์</small>
            </div>
            <div className="row g-3 g-lg-4">
              {features.map((f) => (
                <div className="col-6 col-lg-3" key={f.title}>
                  <div className="home-feature-card h-100">
                    <span className="home-feature-card__icon" aria-hidden="true">{f.icon}</span>
                    <b className="home-feature-card__title text-white">{f.title}</b>
                    <small className="home-feature-card__desc text-white-50">{f.desc}</small>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <Footer />
      </div>
    );
  }
}
